// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1C8CL","modalForm":"UpgradeEpcsModal_modalForm__240RT","modalFooter":"UpgradeEpcsModal_modalFooter__3j4pX"};